import React from "react";
import images from "../../../Utils/importImages";
import "./UserInfoSection.css";
import { useDispatch, useSelector } from "react-redux";

function UserInfoSection() {

    let dispatch = useDispatch();
  
    const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
      (state) => state.user
    );

    let getName = () => {
      if (isUserLogin != true) {
        return userLoggedInData?.fullName || "---";
      }

      let firstName = userLoggedInData?.user_data?.first_name;
      let lastName = userLoggedInData?.user_data?.last_name;

      let name = [firstName, lastName].filter(Boolean).join(" ").trim();

      return name || "Traveller";
    };
  
    let getEmail = () => {
      return userLoggedInData?.email || "---"
    };

    let getPhone = () => {
    return userLoggedInData?.phone || "---"
    };

  return (
    <div className="userdb-content-left">
      <div className="userdb-content-left-internal">
        <div className="userdb-username">
          <div className="userdefaultimg">
            <img src={images["Symbols.svg"]} alt="" />
          </div>
          {getName()}
        </div>
        <ul className="userdb-personal-detail">
          <li>
            <img src={images["userdb-email.svg"]} alt="" />{" "}
            {getEmail()}
          </li>
          <li>
            <img src={images["userdb-phone.svg"]} alt="" />
            {getPhone()}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default UserInfoSection;
